// Hvor langt eleven har kommet: brukes i bunnlinja, sideoversikten og PDF-en.

export const countWords = (text) => {
  const trimmed = (text || '').trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
};

export const isAnswered = (text) => (text || '').trim().length > 0;

// Status for én side. index 0 er forsiden.
export const pageStatus = (book, index, answers, name) => {
  if (index === 0) {
    return isAnswered(name)
      ? { tone: 'done', text: 'Navn skrevet' }
      : { tone: 'todo', text: 'Skriv navnet ditt' };
  }
  const page = book.pages[index - 1];
  const pageAnswers = answers[`page_${index}`] || [];
  if (page.mode === 'referat') {
    const words = countWords(pageAnswers[0]);
    return words > 0
      ? { tone: 'done', text: `Referat · ${words} ord` }
      : { tone: 'todo', text: 'Ikke begynt' };
  }
  const total = page.questions.length;
  const done = page.questions.filter((_, i) => isAnswered(pageAnswers[i])).length;
  if (done === total) return { tone: 'done', text: `Ferdig · ${done} av ${total} svar` };
  if (done > 0) return { tone: 'partial', text: `${done} av ${total} svar` };
  return { tone: 'todo', text: 'Ikke begynt' };
};

// Totalt for hele boka, til sideoversikten.
export const bookProgress = (book, answers) => {
  let total = 0;
  let done = 0;
  book.pages.forEach((page, i) => {
    const pageAnswers = answers[`page_${i + 1}`] || [];
    if (page.mode === 'referat') {
      total += 1;
      if (isAnswered(pageAnswers[0])) done += 1;
    } else {
      total += page.questions.length;
      done += page.questions.filter((_, q) => isAnswered(pageAnswers[q])).length;
    }
  });
  const unit = book.pages[0]?.mode === 'referat' ? 'referater' : 'svar';
  return { total, done, text: `${done} av ${total} ${unit} skrevet` };
};
